// src/components/Cta.js

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Cta = () => {
    const [isMobile, setIsMobile] = useState(false);
    
    // Check if we're on mobile
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768); // 768px is md: breakpoint
        };
        
        // Initial check
        checkMobile();
        
        // Add event listener for resize
        window.addEventListener('resize', checkMobile);
        
        // Cleanup
        return () => {
            window.removeEventListener('resize', checkMobile);
        };
    }, []);
    
    // Apply the appropriate class based on the device type
    const backgroundClass = isMobile ? "bg-gradient-to-b from-white to-mm_blue" : "cta";
    
    return ( 
        <div className={`w-full flex items-center justify-center text-black ${backgroundClass}`}>
            <div className="w-9/12 h-96 text-center lg:text-left flex lg:justify-between items-center">                    
                <div className="w-full flex flex-col lg:justify-around md:ml-12 ml-0">
                    <div className="mb-4 lg:w-3/4 md:bg-opacity-30 md:px-10 md:py-5 md:bg-black md:p-4 rounded-2xl">
                        <p className='text-2xl md:text-4xl font-extrabold mb-4 text-black md:text-white'>Want to learn more about hair transplants?</p>
                        <p className="lg:w-3/4 text-lg font-bold md:text-2xl md:text-white"> Check out our beginners guide that covers all fundamental aspects about hair transplants.</p>
                        <div className="w-full lg:w-72 pt-6 md:ml-2">
                            <Link to="/guide" className="bg-white md:bg-white hover:bg-gray-200 text-black justify-center text-center rounded-lg px-10 py-3 flex items-center font-semibold group">The Guide
                            <svg className="w-5 h-5 ml-1 group-hover:translate-x-2 duration-500 ease-in" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default Cta;